import { c as _c } from "react/compiler-runtime";
// The one section head: small caps over a group (Settings, Usage, the nav's sections, where it sticks frosted under
// the brand bar). An optional action sits on the right (a LinkButton). Styles: book.css `.section-head`.
import type { ReactNode } from "react";
export function SectionHead(t0) {
  const $ = _c(5);
  const {
    children,
    action
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span>{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== action || $[3] !== t1) {
    t2 = <h3 className="section-head">{t1}{action}</h3>;
    $[2] = action;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}